function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import "./insuredItems.scss";
import { FaTimesCircle, FaPlus } from "react-icons/fa";
import ItemAseguradoForm from "../../../../itemAsegurado/ItemAseguradoForm";
import defaultItemAsegurado from "../../../../itemAsegurado/defaultItemAsegurado";

var InsuredItems = function InsuredItems(props) {
  var poliza = props.poliza,
      onChange = props.onChange,
      onChangeToStep = props.onChangeToStep,
      regions = props.regions,
      comunas = props.comunas;

  var _React$useState = React.useState(poliza.item_asegurados),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      itemAsegurados = _React$useState2[0],
      setItemAsegurados = _React$useState2[1];

  var onChangeItem = function onChangeItem(newItem, index) {
    var newItemAsegurados = _toConsumableArray(itemAsegurados);

    newItemAsegurados[index] = newItem;
    setItemAsegurados(_toConsumableArray(newItemAsegurados));
    onChange(_objectSpread(_objectSpread({}, poliza), {}, {
      item_asegurados: newItemAsegurados
    }));
  };

  var addItem = function addItem() {
    return setItemAsegurados([].concat(_toConsumableArray(itemAsegurados), [defaultItemAsegurado]));
  };

  var deleteItem = function deleteItem(index) {
    var newItemAsegurados = _toConsumableArray(itemAsegurados);

    newItemAsegurados.splice(index, 1);
    setItemAsegurados(_toConsumableArray(newItemAsegurados));
    onChange(_objectSpread(_objectSpread({}, poliza), {}, {
      item_asegurados: newItemAsegurados
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cntInsuredItems"
  }, itemAsegurados.map(function (itemAsegurado, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "itemTitle"
    }, /*#__PURE__*/React.createElement("p", null, "Item ", index + 1), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-danger",
      onClick: function onClick() {
        return deleteItem(index);
      }
    }, /*#__PURE__*/React.createElement(FaTimesCircle, null))), /*#__PURE__*/React.createElement(ItemAseguradoForm, {
      index: index,
      onChange: function onChange(itemWithChanges) {
        return onChangeItem(itemWithChanges, index);
      },
      poliza: poliza,
      itemAsegurado: itemAsegurado,
      onChangeToStep: onChangeToStep,
      regions: regions,
      comunas: comunas
    }));
  }), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-default",
    style: {
      marginLeft: "10px"
    },
    onClick: addItem
  }, /*#__PURE__*/React.createElement(FaPlus, null), "Agregar otro Item Asegurado"));
};

export default InsuredItems;